import {
  ModuleInfo
} from '@/config/nameConfig'

import DbTypes from '@/modules/storage/dbTypes'

export default {
  name: 'appInfo.db',
  location: 'default',
  version: '1.0',
  tables: [
    // {
    //   name: ModuleInfo.Tables.ReportingAppSessions,
    //   columns: [
    //     {
    //       name: 'Id',
    //       type: DbTypes.INTEGER
    //     },
    //     {
    //       name: 'AppGUID',
    //       type: DbTypes.TEXT
    //     },
    //     {
    //       name: 'SessionStart',
    //       type: DbTypes.TEXT
    //     },
    //     {
    //       name: 'SessionEnd',
    //       type: DbTypes.TEXT
    //     }
    //   ]
    // },
    // {
    //   name: ModuleInfo.Tables.ReportingPageViews,
    //   columns: [
    //     {
    //       name: 'Id',
    //       type: DbTypes.INTEGER
    //     },
    //     {
    //       name: 'AppGUID',
    //       type: DbTypes.TEXT
    //     },
    //     {
    //       name: 'SubscriptionModuleActivation_Id',
    //       type: DbTypes.INTEGER
    //     },
    //     {
    //       name: 'ViewEntered',
    //       type: DbTypes.TEXT
    //     },
    //     {
    //       name: 'ViewLeft',
    //       type: DbTypes.TEXT
    //     }
    //   ]
    // },
    {
      name: ModuleInfo.Tables.SubscriptionsDesignSettings,
      columns: [
        {
          name: 'Id',
          type: DbTypes.INTEGER
        },
        {
          name: 'Subscription_Id',
          type: DbTypes.INTEGER
        },
        {
          name: 'BackgroundThemeMode',
          type: DbTypes.INTEGER
        },
        {
          name: 'BackgroundTheme_Id',
          type: DbTypes.INTEGER
        },
        {
          name: 'BackgroundColor',
          type: DbTypes.INTEGER
        },
        {
          name: 'BackgroundColorElements',
          type: DbTypes.INTEGER
        },
        {
          name: 'BackgroundFontColor',
          type: DbTypes.INTEGER
        },
        {
          name: 'BackgroundImage',
          type: DbTypes.TEXT
        },
        {
          name: 'BackgroundImageOpacity',
          type: DbTypes.NUMERIC
        },
        {
          name: 'AppTheme_Id',
          type: DbTypes.INTEGER
        },
        {
          name: 'AppThemeColor',
          type: DbTypes.INTEGER
        },
        {
          name: 'AppThemeFontColor',
          type: DbTypes.INTEGER
        },
        {
          name: 'AppThemeSecondaryFontColor',
          type: DbTypes.INTEGER
        },
        {
          name: 'TitleBarFontName',
          type: DbTypes.TEXT
        },
        {
          name: 'TitleBarFontColor',
          type: DbTypes.INTEGER
        },
        {
          name: 'TitleBarOpacity',
          type: DbTypes.NUMERIC
        },
        {
          name: 'AppDefaultFont_Id',
          type: DbTypes.INTEGER
        },
        {
          name: 'AppDefaultFont',
          type: DbTypes.TEXT
        },
        {
          name: 'RowCreated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowUpdated',
          type: DbTypes.NUMERIC
        }
      ]
    },
    {
      name: ModuleInfo.Tables.SubscriptionsStartPages,
      columns: [
        {
          name: 'Id',
          type: DbTypes.INTEGER
        },
        {
          name: 'Subscription_Id',
          type: DbTypes.INTEGER
        },
        {
          name: 'MainMenuLayout',
          type: DbTypes.INTEGER
        },
        {
          name: 'BackgroundMode',
          type: DbTypes.INTEGER
        },
        {
          name: 'BackgroundImage',
          type: DbTypes.TEXT
        },
        {
          name: 'Content',
          type: DbTypes.TEXT
        },
        {
          name: 'ContentScrollable',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'MenuItemFontName',
          type: DbTypes.TEXT
        },
        {
          name: 'MenuItemFontColor',
          type: DbTypes.INTEGER
        },
        {
          name: 'MenuItemAlignment',
          type: DbTypes.INTEGER
        },
        {
          name: 'MenuItemContainerOpacity',
          type: DbTypes.NUMERIC
        },
        {
          name: 'MenuItemOverflowBackgroundColor',
          type: DbTypes.INTEGER
        },
        {
          name: 'MenuItemOverflowIcon',
          type: DbTypes.TEXT
        },
        {
          name: 'MenuItemOverflowIconOutlined',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'MenuItemOverflowLabel',
          type: DbTypes.TEXT
        },
        {
          name: 'TitleBarVisible',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'TitleBarTitleMode',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'TitleBarTitle',
          type: DbTypes.TEXT
        },
        {
          name: 'TitleBarLogo',
          type: DbTypes.TEXT
        },
        {
          name: 'TitleBarFontName',
          type: DbTypes.TEXT
        },
        {
          name: 'TitleBarFontColor',
          type: DbTypes.INTEGER
        },
        {
          name: 'TitleBarOpacity',
          type: DbTypes.NUMERIC
        },
        {
          name: 'AppDefaultFont_Id',
          type: DbTypes.INTEGER
        },
        {
          name: 'AppDefaultFont',
          type: DbTypes.TEXT
        },
        {
          name: 'LegalInformation',
          type: DbTypes.TEXT
        },
        {
          name: 'RowCreated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowUpdated',
          type: DbTypes.NUMERIC
        }
      ]
    },
    {
      name: ModuleInfo.Tables.SubscriptionsModules,
      columns: [
        {
          name: 'Id',
          type: DbTypes.INTEGER
        },
        {
          name: 'RowCreated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowUpdated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'HideModule',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'AccessLocked',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'RowDeleted',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'Module_Id',
          type: DbTypes.INTEGER
        },
        {
          name: 'ChildOf',
          type: DbTypes.INTEGER
        },
        {
          name: 'OrderId',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'ModuleName',
          type: DbTypes.TEXT
        },
        {
          name: 'MenuIcon',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'MenuIconColor',
          type: DbTypes.INTEGER
        },
        {
          name: 'MenuIconOutlined',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'MenuLabel',
          type: DbTypes.TEXT
        },
        {
          name: 'BasedOnModule_Id',
          type: DbTypes.INTEGER
        }
      ]
    },
    {
      name: ModuleInfo.Tables.ReportingRegisteredApps,
      columns: [
        {
          name: 'AppGUID',
          type: DbTypes.TEXT
        },
        {
          name: 'Subscription_Id',
          type: DbTypes.INTEGER
        },
        {
          name: 'AppType',
          type: DbTypes.INTEGER
        },
        {
          name: 'RegistrationDate',
          type: DbTypes.TEXT
        },
        {
          name: 'DeviceCountry',
          type: DbTypes.TEXT
        },
        {
          name: 'DeviceModel',
          type: DbTypes.TEXT
        },
        {
          name: 'DevicePlatform',
          type: DbTypes.TEXT
        },
        {
          name: 'DeviceVersion',
          type: DbTypes.TEXT
        }
      ]
    },
    {
      name: ModuleInfo.Tables.ReportingUserLikes,
      columns: [
        {
          name: 'Id',
          type: DbTypes.INTEGER
        },
        {
          name: 'AppGUID',
          type: DbTypes.TEXT
        },
        {
          name: 'ContentType',
          type: DbTypes.INTEGER
        },
        {
          name: 'Reference_Id',
          type: DbTypes.TEXT
        },
        {
          name: 'LikeDate',
          type: DbTypes.TEXT
        },
        {
          name: 'Liked',
          type: DbTypes.BOOLEAN
        }
      ]
    },
    {
      name: ModuleInfo.Tables.ModulesCustomCode,
      columns: [
        {
          name: 'Id',
          type: DbTypes.TEXT
        },
        {
          name: 'RowCreated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowUpdated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowDeleted',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'SubscriptionModule_Id',
          type: DbTypes.INTEGER
        },
        {
          name: 'PageTitle',
          type: DbTypes.TEXT
        },
        {
          name: 'CustomCodeCSS',
          type: DbTypes.TEXT
        },
        {
          name: 'CustomCodeHTML',
          type: DbTypes.TEXT
        },
        {
          name: 'CustomCodeJavaScript',
          type: DbTypes.TEXT
        }
      ]
    },
    {
      name: ModuleInfo.Tables.ModulesFacebook,
      columns: [
        {
          name: 'Id',
          type: DbTypes.TEXT
        },
        {
          name: 'RowCreated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowUpdated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowDeleted',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'SubscriptionModule_Id',
          type: DbTypes.INTEGER
        },
        {
          name: 'PageTitle',
          type: DbTypes.TEXT
        },
        {
          name: 'FacebookId',
          type: DbTypes.TEXT
        },
        {
          name: 'FacebookToken',
          type: DbTypes.TEXT
        }
      ]
    },
    {
      name: ModuleInfo.Tables.ModulesTwitter,
      columns: [
        {
          name: 'Id',
          type: DbTypes.TEXT
        },
        {
          name: 'RowCreated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowUpdated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowDeleted',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'SubscriptionModule_Id',
          type: DbTypes.INTEGER
        },
        {
          name: 'PageTitle',
          type: DbTypes.TEXT
        },
        {
          name: 'TwitterId',
          type: DbTypes.TEXT
        },
        {
          name: 'TwitterToken',
          type: DbTypes.TEXT
        }
      ]
    },
    {
      name: ModuleInfo.Tables.ModulesInstagram,
      columns: [
        {
          name: 'Id',
          type: DbTypes.TEXT
        },
        {
          name: 'RowCreated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowUpdated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowDeleted',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'SubscriptionModule_Id',
          type: DbTypes.INTEGER
        },
        {
          name: 'PageTitle',
          type: DbTypes.TEXT
        },
        {
          name: 'InstagramId',
          type: DbTypes.TEXT
        },
        {
          name: 'InstagramToken',
          type: DbTypes.TEXT
        }
      ]
    },
    {
      name: ModuleInfo.Tables.ModulesWebsite,
      columns: [
        {
          name: 'Id',
          type: DbTypes.TEXT
        },
        {
          name: 'RowCreated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowUpdated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowDeleted',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'SubscriptionModule_Id',
          type: DbTypes.INTEGER
        },
        {
          name: 'PageTitle',
          type: DbTypes.TEXT
        },
        {
          name: 'WebsiteURL',
          type: DbTypes.TEXT
        },
        {
          name: 'WebNavBarMode',
          type: DbTypes.NUMERIC
        }
      ]
    },
    {
      name: ModuleInfo.Tables.ModulesYoutube,
      columns: [
        {
          name: 'Id',
          type: DbTypes.TEXT
        },
        {
          name: 'RowCreated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowUpdated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowDeleted',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'SubscriptionModule_Id',
          type: DbTypes.INTEGER
        },
        {
          name: 'PageTitle',
          type: DbTypes.TEXT
        },
        {
          name: 'YouTubeChannel',
          type: DbTypes.TEXT
        },
        {
          name: 'YouTubeAPIKey',
          type: DbTypes.TEXT
        }
      ]
    },
    {
      name: ModuleInfo.Tables.ModulesRSSFeed,
      columns: [
        {
          name: 'Id',
          type: DbTypes.TEXT
        },
        {
          name: 'RowCreated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowUpdated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowDeleted',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'SubscriptionModule_Id',
          type: DbTypes.INTEGER
        },
        {
          name: 'PageTitle',
          type: DbTypes.TEXT
        },
        {
          name: 'RSSFeedURL',
          type: DbTypes.TEXT
        }
      ]
    },
    {
      name: ModuleInfo.Tables.ModulesChats,
      columns: [
        {
          name: 'Id',
          type: DbTypes.TEXT
        },
        {
          name: 'RowCreated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowUpdated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowDeleted',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'SubscriptionModule_Id',
          type: DbTypes.INTEGER
        },
        {
          name: 'PageTitle',
          type: DbTypes.TEXT
        }       
      ]
    },
    // {
    //   name: ModuleInfo.Tables.SubscriptionsAppImages,
    //   columns: [
    //     {
    //       name: 'Id',
    //       type: DbTypes.INTEGER
    //     },
    //     {
    //       name: 'Subscription_Id',
    //       type: DbTypes.INTEGER
    //     },
    //     {
    //       name: 'ImageThumbnail',
    //       type: DbTypes.TEXT
    //     },
    //     {
    //       name: 'ImagePreview',
    //       type: DbTypes.TEXT
    //     },
    //     {
    //       name: 'ImageFullsize',
    //       type: DbTypes.TEXT
    //     },
    //     {
    //       name: 'ImageResolution',
    //       type: DbTypes.TEXT
    //     },
    //     {
    //       name: 'IncludeInAppDistribution',
    //       type: DbTypes.TEXT
    //     },
    //     {
    //       name: 'ProvideForOnlineContent',
    //       type: DbTypes.NUMERIC
    //     }
    //   ]
    // },
    {
      name: ModuleInfo.Tables.ModulesContentPages,
      columns: [
        {
          name: 'Id',
          type: DbTypes.TEXT
        },
        {
          name: 'RowCreated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowUpdated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowDeleted',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'SubscriptionModule_Id',
          type: DbTypes.INTEGER
        },
        {
          name: 'PageTitle',
          type: DbTypes.TEXT
        },
        {
          name: 'FooterElements',
          type: DbTypes.TEXT
        },
        {
          name: 'HeaderElements',
          type: DbTypes.TEXT
        },
        {
          name: 'UseCategories',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'PostCategories',
          type: DbTypes.TEXT
        },
        {
          name: 'AllowMultiplePosts',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'AllowLikes',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'AllowComments',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'ConfirmComments',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'AllowSharing',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'AllowAddingToFavorites',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'POIInitalMapLocation',
          type: DbTypes.TEXT
        },
        {
          name: 'POIInitialZoomLevel',
          type: DbTypes.INTEGER
        },
        {
          name: 'ShowPostHeaderOnDetailPage',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'POIInitialShowList',
          type: DbTypes.BOOLEAN
        }
      ]
    },
    {
      name: ModuleInfo.Tables.ModulesContentPagesPosts,
      columns: [
        {
          name: 'Id',
          type: DbTypes.TEXT
        },
        {
          name: 'RowCreated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowUpdated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowDeleted',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'ModulesContentPages_Id',
          type: DbTypes.TEXT
        },
        {
          name: 'Category',
          type: DbTypes.TEXT
        },
        {
          name: 'OrderId',
          type: DbTypes.INTEGER
        },
        {
          name: 'Title',
          type: DbTypes.TEXT
        },
        {
          name: 'Content',
          type: DbTypes.TEXT
        },
        {
          name: 'EventLocation',
          type: DbTypes.TEXT
        },
        {
          name: 'PostDate',
          type: DbTypes.TEXT
        },
        {
          name: 'PostAuthor',
          type: DbTypes.TEXT
        },
        {
          name: 'EventStartDate',
          type: DbTypes.TEXT
        },
        {
          name: 'EventEndDate',
          type: DbTypes.TEXT
        },
        {
          name: 'EventStartTime',
          type: DbTypes.TEXT
        },
        {
          name: 'EventEndTime',
          type: DbTypes.TEXT
        },
        {
          name: 'MapAddressLine1',
          type: DbTypes.TEXT
        },
        {
          name: 'MapAddressLine2',
          type: DbTypes.BOOLEAN
        },
        // {
        //   name: 'PostImage_Id',
        //   type: DbTypes.INTEGER
        // },
        {
          name: 'PostImage',
          type: DbTypes.TEXT
        },
        {
          name: 'Active',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'PostLikes',
          type: DbTypes.NUMERIC
        },
        {
          name: 'IsLiked',
          type: DbTypes.BOOLEAN
        }
      ]
    },
    {
      name: ModuleInfo.Tables.ModulesContentPagesPostsComments,
      columns: [
        {
          name: 'Id',
          type: DbTypes.TEXT
        },
        {
          name: 'RowCreated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowUpdated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowDeleted',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'ModulesContentPagesPosts_Id',
          type: DbTypes.TEXT
        },
        {
          name: 'CommentDate',
          type: DbTypes.TEXT
        },
        {
          name: 'CommentAuthor',
          type: DbTypes.TEXT
        },
        {
          name: 'Comment',
          type: DbTypes.TEXT
        },
        {
          name: 'CommentEmail',
          type: DbTypes.TEXT
        }

      ]
    },
    {
      name: ModuleInfo.Tables.ModulesImageGalleries,
      columns: [
        {
          name: 'Id',
          type: DbTypes.TEXT
        },
        {
          name: 'RowCreated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowUpdated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowDeleted',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'SubscriptionModule_Id',
          type: DbTypes.INTEGER
        },
        {
          name: 'PageTitle',
          type: DbTypes.TEXT
        },
        {
          name: 'PostCategories',
          type: DbTypes.TEXT
        },
        {
          name: 'FooterElements',
          type: DbTypes.TEXT
        },
        {
          name: 'HeaderElements',
          type: DbTypes.TEXT
        },
        {
          name: 'UseCategories',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'AllowLikes',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'AllowSharing',
          type: DbTypes.BOOLEAN
        }
      ]
    },
    {
      name: ModuleInfo.Tables.ModulesImageGalleriesAlbums,
      columns: [
        {
          name: 'Id',
          type: DbTypes.TEXT
        },
        {
          name: 'RowCreated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowUpdated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowDeleted',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'ModulesImageGalleries_Id',
          type: DbTypes.TEXT
        },
        {
          name: 'Category',
          type: DbTypes.TEXT
        },
        {
          name: 'OrderId',
          type: DbTypes.INTEGER
        },
        {
          name: 'AlbumName',
          type: DbTypes.TEXT
        },
        {
          name: 'PostDate',
          type: DbTypes.TEXT
        },
        {
          name: 'PostAuthor',
          type: DbTypes.TEXT
        },
        {
          name: 'Likes',
          type: DbTypes.NUMERIC
        }
      ]
    },
    {
      name: ModuleInfo.Tables.ModulesImageGalleriesAlbumsImages,
      columns: [
        {
          name: 'Id',
          type: DbTypes.TEXT
        },
        {
          name: 'RowCreated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowUpdated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowDeleted',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'ModulesImageGalleriesAlbums_Id',
          type: DbTypes.TEXT
        },
        {
          name: 'OrderId',
          type: DbTypes.INTEGER
        },
        // {
        //   name: 'Image_Id',
        //   type: DbTypes.INTEGER
        // },
        {
          name: 'Description',
          type: DbTypes.TEXT
        },
        {
          name: 'Image',
          type: DbTypes.TEXT
        },
        {
          name: 'IsLiked',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'Likes',
          type: DbTypes.NUMERIC
        }
      ]
    },
    {
      name: ModuleInfo.Tables.ModulesTeamMembers,
      columns: [
        {
          name: 'Id',
          type: DbTypes.TEXT
        },
        {
          name: 'RowCreated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowUpdated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowDeleted',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'SubscriptionModule_Id',
          type: DbTypes.INTEGER
        },
        {
          name: 'PageTitle',
          type: DbTypes.TEXT
        },
        {
          name: 'FooterElements',
          type: DbTypes.TEXT
        },
        {
          name: 'HeaderElements',
          type: DbTypes.TEXT
        }

      ]
    },
    {
      name: ModuleInfo.Tables.ModulesTeamMembersPersons,
      columns: [
        {
          name: 'Id',
          type: DbTypes.TEXT
        },
        {
          name: 'RowCreated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowUpdated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowDeleted',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'ModulesTeamMembers_Id',
          type: DbTypes.TEXT
        },
        {
          name: 'OrderId',
          type: DbTypes.INTEGER
        },
        // {
        //   name: 'PersonImage_Id',
        //   type: DbTypes.INTEGER
        // },
        {
          name: 'PersonImage',
          type: DbTypes.TEXT
        },
        {
          name: 'PersonName',
          type: DbTypes.TEXT
        },
        {
          name: 'PersonPosition',
          type: DbTypes.TEXT
        },
        {
          name: 'PersonDescription',
          type: DbTypes.TEXT
        },
        {
          name: 'Phone',
          type: DbTypes.TEXT
        },
        {
          name: 'Email',
          type: DbTypes.TEXT
        }
      ]
    },
    {
      name: ModuleInfo.Tables.LastSyncInfo,
      columns: [
        {
          name: 'LastSync',
          type: DbTypes.NUMERIC
        },
        {
          name: 'SyncFor',
          type: DbTypes.INTEGER
        },
        {
          name: 'ModuleActivationId',
          type: DbTypes.INTEGER
        }
      ]
    },
    {
      name: ModuleInfo.Tables.UserActionQueue,
      columns: [
        {
          name: 'Id',
          type: DbTypes.TEXT
        },
        {
          name: 'RowCreated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'Subscription_Id',
          type: DbTypes.INTEGER
        },
        {
          name: 'ActionType',
          type: DbTypes.INTEGER
        },
        {
          name: 'Payload',
          type: DbTypes.TEXT
        }
      ]
    },
    {
      name: ModuleInfo.Tables.ModulesRadioStream,
      columns: [
        {
          name: 'Id',
          type: DbTypes.TEXT
        },
        {
          name: 'RowCreated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowUpdated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'SubscriptionModule_Id',
          type: DbTypes.NUMERIC
        },
        {
          name: 'PageTitle',
          type: DbTypes.TEXT
        },
        {
          name: 'StreamURL',
          type: DbTypes.TEXT
        },
        {
          name: 'StreamCaption',
          type: DbTypes.TEXT
        },
        // {
        //   name: 'StreamCoverImage_Id',
        //   type: DbTypes.NUMERIC
        // },
        {
          name: 'StreamCoverImage',
          type: DbTypes.TEXT
        },
        {
          name: 'IsLiked',
          type: DbTypes.BOOLEAN
        }
      ]
    },
    {
      name: ModuleInfo.Tables.ModulesForms,
      columns: [
        {
          name: 'Id',
          type: DbTypes.TEXT
        },
        {
          name: 'RowCreated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowUpdated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'SubscriptionModule_Id',
          type: DbTypes.NUMERIC
        },
        {
          name: 'PageTitle',
          type: DbTypes.TEXT
        },
        {
          name: 'FormFields',
          type: DbTypes.TEXT
        },
        {
          name: 'AlertOnNewFormSubmission',
          type: DbTypes.BOOLEAN
        },
        {
          name: 'AlertEmailAddress',
          type: DbTypes.TEXT
        },
        {
          name: 'AlertEmailSubject',
          type: DbTypes.TEXT
        },
        {
          name: 'SubmitButtonLabel',
          type: DbTypes.TEXT
        },
        {
          name: 'SubmitSuccessMessage',
          type: DbTypes.TEXT
        },
        {
          name: 'SubmitErrorMessage',
          type: DbTypes.TEXT
        }
      ]
    },
    {
      name: ModuleInfo.Tables.ModulesPDF,
      columns: [
        {
          name: 'Id',
          type: DbTypes.TEXT
        },
        {
          name: 'RowCreated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'RowUpdated',
          type: DbTypes.NUMERIC
        },
        {
          name: 'SubscriptionModule_Id',
          type: DbTypes.INTEGER
        },
        {
          name: 'PageTitle',
          type: DbTypes.TEXT
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/modules/storage/dbConfig.js